var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSetup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    contentScriptType: "text/ecmascript",
    contentStyleType: "text/css",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    zoomAndPan: "magnify",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", {
    id: "setup_glyph-0-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16.203-7c0-1.0312-0.37109-1.8203-1.1094-2.375-0.73047-0.5625-2.0469-1.1484-3.9531-1.7656-1.8984-0.61328-3.4023-1.2227-4.5156-1.8281-3.0234-1.6328-4.5312-3.8359-4.5312-6.6094 0-1.4375 0.39844-2.7188 1.2031-3.8438 0.8125-1.1328 1.9766-2.0195 3.5-2.6562 1.5195-0.63281 3.2266-0.95312 5.125-0.95312 1.9062 0 3.6016 0.35156 5.0938 1.0469 1.4883 0.6875 2.6445 1.6641 3.4688 2.9219 0.82031 1.25 1.2344 2.6797 1.2344 4.2812h-5.5c0-1.2266-0.38672-2.1797-1.1562-2.8594-0.76172-0.67578-1.8398-1.0156-3.2344-1.0156-1.3438 0-2.3906 0.28906-3.1406 0.85938-0.74219 0.5625-1.1094 1.3086-1.1094 2.2344 0 0.875 0.4375 1.6055 1.3125 2.1875 0.875 0.58594 2.1602 1.1328 3.8594 1.6406 3.125 0.94922 5.3984 2.1211 6.8281 3.5156 1.4258 1.3867 2.1406 3.1172 2.1406 5.1875 0 2.3047-0.875 4.1094-2.625 5.4219-1.7422 1.3125-4.0898 1.9688-7.0469 1.9688-2.0547 0-3.9219-0.375-5.6094-1.125-1.6797-0.75-2.9609-1.7734-3.8438-3.0781-0.88672-1.3008-1.3281-2.8164-1.3281-4.5469h5.5156c0 2.9492 1.7539 4.4219 5.2656 4.4219 1.3008 0 2.3164-0.26562 3.0469-0.79688 0.73828-0.53125 1.1094-1.2734 1.1094-2.2344z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "setup_glyph-0-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11.156 0.35938c-2.9062 0-5.2773-0.89062-7.1094-2.6719-1.8242-1.7812-2.7344-4.1562-2.7344-7.125v-0.5c0-1.9883 0.38281-3.7695 1.1562-5.3438 0.76953-1.5703 1.8594-2.7812 3.2656-3.625 1.4141-0.84375 3.0234-1.2656 4.8281-1.2656 2.707 0 4.8359 0.85547 6.3906 2.5625 1.5625 1.7109 2.3438 4.1328 2.3438 7.2656v2.1562h-12.609c0.16406 1.293 0.67578 2.3281 1.5312 3.1094 0.86328 0.78125 1.957 1.1719 3.2812 1.1719 2.0391 0 3.6328-0.73438 4.7812-2.2031l2.5938 2.9062c-0.79297 1.125-1.8672 2-3.2188 2.625-1.3555 0.625-2.8555 0.9375-4.5 0.9375zm-0.60938-16.25c-1.0547 0-1.9062 0.35547-2.5625 1.0625-0.64844 0.71094-1.0625 1.7188-1.25 3.0312h7.3594v-0.42188c-0.02344-1.1641-0.33984-2.0664-0.95312-2.7031-0.60547-0.64453-1.4688-0.96875-2.5938-0.96875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "setup_glyph-0-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.375-24.688v4.875h3.375v3.875h-3.375v9.8906c0 0.74219 0.13281 1.2734 0.40625 1.5938 0.28125 0.3125 0.82031 0.46875 1.625 0.46875 0.58203 0 1.0977-0.046875 1.5469-0.14062v4.0156c-1.0312 0.3125-2.1016 0.46875-3.2031 0.46875-3.7109 0-5.6016-1.8672-5.6719-5.6094v-10.688h-2.8906v-3.875h2.8906v-4.875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "setup_glyph-0-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.891-2.0156c-1.3047 1.5859-3.1055 2.375-5.4062 2.375-2.125 0-3.75-0.60938-4.875-1.8281-1.1172-1.2188-1.6836-3.0039-1.7031-5.3594v-12.984h5.2969v12.797c0 2.0625 0.9375 3.0938 2.8125 3.0938 1.7891 0 3.0234-0.61719 3.7031-1.8594v-14.031h5.3125v19.812h-4.9844z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "setup_glyph-0-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m19.859-9.7188c0 3.0547-0.69531 5.4961-2.0781 7.3281-1.3867 1.8359-3.2578 2.75-5.6094 2.75-2 0-3.6172-0.69141-4.8438-2.0781v9.3438h-5.2969v-27.438h4.9062l0.1875 1.9375c1.2812-1.5312 2.9531-2.2969 5.0156-2.2969 2.4375 0 4.332 0.90234 5.6875 2.7031 1.3516 1.8047 2.0312 4.293 2.0312 7.4688zm-5.2812-0.39062c0-1.8438-0.32812-3.2656-0.98438-4.2656s-1.6055-1.5-2.8438-1.5c-1.6562 0-2.7969 0.63672-3.4219 1.9062v8.1094c0.64453 1.3047 1.7969 1.9531 3.4531 1.9531 2.5312 0 3.7969-2.0664 3.7969-6.2031z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "setup_glyph-0-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.516 0c-0.25-0.47656-0.42969-1.0703-0.53125-1.7812-1.2812 1.4297-2.9492 2.1406-5 2.1406-1.9375 0-3.5469-0.55469-4.8281-1.6719-1.2734-1.125-1.9062-2.5391-1.9062-4.25 0-2.1016 0.77344-3.7109 2.3281-4.8281 1.5625-1.125 3.8125-1.6953 6.75-1.7188h2.4375v-1.125c0-0.91406-0.23438-1.6484-0.70312-2.2031-0.46875-0.55078-1.2148-0.82812-2.2344-0.82812-0.88672 0-1.5859 0.21484-2.0938 0.64062-0.51172 0.42969-0.76562 1.0156-0.76562 1.7656h-5.2812c0-1.1445 0.35156-2.207 1.0625-3.1875 0.70703-0.97656 1.707-1.7422 3-2.2969 1.2891-0.55078 2.7422-0.82812 4.3594-0.82812 2.4375 0 4.375 0.61719 5.8125 1.8438 1.4375 1.2188 2.1562 2.9375 2.1562 5.1562v8.5938c0.0078 1.875 0.26953 3.2969 0.78125 4.2656v0.3125zm-4.375-3.6875c0.78125 0 1.5-0.17188 2.1562-0.51562s1.1445-0.8125 1.4688-1.4062v-3.4062h-1.9844c-2.6484 0-4.0547 0.91797-4.2188 2.75l-0.03125 0.3125c0 0.65625 0.22656 1.1992 0.6875 1.625 0.46875 0.42969 1.1094 0.64062 1.9219 0.64062z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "setup_glyph-0-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.9062-19.812 0.15625 2.2969c1.4141-1.7695 3.3164-2.6562 5.7031-2.6562 2.0938 0 3.6484 0.61719 4.6719 1.8438 1.0312 1.2305 1.5625 3.0742 1.5938 5.5312v12.797h-5.2969v-12.672c0-1.125-0.24609-1.9375-0.73438-2.4375-0.49219-0.50781-1.3047-0.76562-2.4375-0.76562-1.4922 0-2.6055 0.63672-3.3438 1.9062v13.969h-5.2969v-19.812z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "setup_glyph-0-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.2031-10.047c0-3.0938 0.69141-5.5508 2.0781-7.375 1.3828-1.832 3.2812-2.75 5.6875-2.75 1.9258 0 3.5195 0.71875 4.7812 2.1562v-10.109h5.3125v28.125h-4.7812l-0.25-2.1094c-1.3242 1.6484-3.0234 2.4688-5.0938 2.4688-2.3359 0-4.2109-0.91406-5.625-2.75-1.4062-1.832-2.1094-4.3828-2.1094-7.6562zm5.2969 0.375c0 1.8555 0.32031 3.2773 0.96875 4.2656 0.64453 0.99219 1.5859 1.4844 2.8281 1.4844 1.6328 0 2.7852-0.6875 3.4531-2.0625v-7.8281c-0.65625-1.375-1.7969-2.0625-3.4219-2.0625-2.5547 0-3.8281 2.0703-3.8281 6.2031z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "setup_glyph-0-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.5625-26.656 6.8438 19.328 6.8125-19.328h7.2188v26.656h-5.5156v-7.2812l0.54688-12.578-7.1875 19.859h-3.7812l-7.1719-19.844 0.54688 12.562v7.2812h-5.5v-26.656z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "setup_glyph-0-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.625 0h-5.3125v-19.812h5.3125zm-5.625-24.938c0-0.78906 0.26562-1.4414 0.79688-1.9531 0.53125-0.51953 1.2539-0.78125 2.1719-0.78125 0.89453 0 1.6094 0.26172 2.1406 0.78125 0.53906 0.51172 0.8125 1.1641 0.8125 1.9531 0 0.80469-0.27344 1.4648-0.8125 1.9844-0.54297 0.51172-1.2617 0.76562-2.1562 0.76562-0.88672 0-1.6016-0.25391-2.1406-0.76562-0.54297-0.51953-0.8125-1.1797-0.8125-1.9844z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "setup_glyph-0-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.266-3.9062c0.97656 0 1.7695-0.26562 2.375-0.79688 0.61328-0.53906 0.9375-1.2539 0.96875-2.1406h4.9531c-0.01172 1.3438-0.375 2.5742-1.0938 3.6875-0.71875 1.1172-1.7031 1.9805-2.9531 2.5938-1.25 0.61328-2.6367 0.92188-4.1562 0.92188-2.8359 0-5.0703-0.89453-6.7031-2.6875-1.6367-1.8008-2.4531-4.2891-2.4531-7.4688v-0.34375c0-3.0508 0.8125-5.4844 2.4375-7.2969 1.625-1.8203 3.8516-2.7344 6.6875-2.7344 2.4766 0 4.4609 0.70312 5.9531 2.1094 1.5 1.4062 2.2578 3.2812 2.2812 5.625h-4.9531c-0.03125-1.0195-0.35547-1.8477-0.96875-2.4844-0.60547-0.64453-1.4062-0.96875-2.4062-0.96875-1.2305 0-2.1641 0.44922-2.7969 1.3438-0.625 0.89844-0.9375 2.3516-0.9375 4.3594v0.5625c0 2.0312 0.3125 3.4961 0.9375 4.3906 0.625 0.88672 1.5664 1.3281 2.8281 1.3281z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "setup_clip-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m80.801 140h104.2v104.5h-104.2z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.072873 0 0 .072873 -1.8864 -1.9231)",
    clipPath: "url(#setup_clip-2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m132.43 168.15c-1.4141-1.4141-1.4141-3.6016 0-5.0156 1.4141-1.4102 3.6094-1.4102 5.0234 0l36.004 35.945 5.8672-5.8633c7.2148-7.2031 7.2148-18.852 0-26.055l-21.078-21.043c-7.2109-7.2031-18.883-7.2031-26.098 0l-45.977 45.898c-3.4648 3.4609-5.375 8.1211-5.375 12.992 0 4.875 1.9102 9.5352 5.375 12.992l1.4844 1.4844 38.195-38.133c1.4141-1.4102 3.6094-1.4102 5.0234 0 1.4141 1.4141 1.4141 3.6016 0 5.0156l-38.195 38.133 9.832 9.8125 38.195-38.129c1.4141-1.4141 3.6055-1.4141 5.0195 0 1.418 1.4102 1.418 3.5977 0 5.0117l-38.191 38.133c3.5352 3.3906 8.1328 5.1562 12.801 5.1562 4.7383 0 9.4766-1.7656 13.016-5.3672l35.082-35.027z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.072873
  }, /*#__PURE__*/React.createElement("path", {
    d: "m17.867 2.5037-0.43809-0.43752c-0.23172-0.23143-0.59267-0.2468-0.84516-0.041l-1.129 0.93653c-0.13408 0.1133-0.21635 0.27783-0.22659 0.4529-0.0105 0.17478 0.0566 0.34984 0.18531 0.47339l0.62369 0.62255c0.1187 0.11842 0.2784 0.18531 0.4435 0.18531h0.0307c0.17535-0.0102 0.34017-0.0925 0.45374-0.2263l0.93796-1.127c0.2115-0.24196 0.19072-0.60747-0.0362-0.8389z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.589 11.005c-0.70083-0.69998-1.7421-0.96244-2.6903-0.6792l-5.8401-5.8304c0.28352-0.94678 0.0205-1.9812-0.68034-2.6861-0.75777-0.75663-1.8916-0.99859-2.8916-0.61259-0.0825 0.031-0.1392 0.10305-0.15998 0.18531-0.0205 0.0823 0.0105 0.17507 0.0723 0.23684l1.1751 1.1731-0.31939 0.74638-0.74752 0.31882-1.1648-1.1628c-0.0618-0.0618-0.14945-0.0874-0.23712-0.0669-0.0877 0.0205-0.15457 0.0823-0.1856 0.16453-0.36067 0.98806-0.1133 2.1048 0.62882 2.8458 0.70111 0.69998 1.7421 0.96244 2.6906 0.6792l5.8401 5.8304c-0.28353 0.94678-0.0208 1.9812 0.68033 2.6863 0.51553 0.51439 1.2112 0.79221 1.9175 0.79221 0.32992 0 0.65956-0.0615 0.97411-0.1799 0.0825-0.031 0.1392-0.10305 0.15969-0.18531 0.0208-0.0874-0.0102-0.17507-0.072-0.23684l-1.1754-1.1731 0.31967-0.74609 0.74752-0.31911 1.1648 1.1628c0.0618 0.0618 0.14945 0.0877 0.23713 0.0669 0.0877-0.0205 0.15457-0.0823 0.18559-0.16453 0.36067-0.98806 0.1133-2.1048-0.6291-2.8458zm-4.4017-0.57132c-0.0515 0.0515-0.11871 0.0772-0.18048 0.0772-0.0618 0-0.13407-0.0256-0.18047-0.0772l-3.9739-3.9673c-0.10304-0.10305-0.10304-0.26246 0-0.36551 0.10305-0.10276 0.26275-0.10276 0.36579 0l3.9742 3.9676c0.0928 0.10277 0.0928 0.26246-5e-3 0.36522z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.559 6.9894 2.9776-2.9727 0.36465 0.3638-2.9778 2.973z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.234 9.3142 0.50641-0.50584 0.36465 0.36408-0.50669 0.50556z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.072873 0 0 .072873 -1.8864 -1.9231)"
  }, /*#__PURE__*/React.createElement("use", {
    x: 102.69141,
    y: 290.10471,
    width: "100%",
    height: "100%",
    xlinkActuate: "onLoad",
    xlinkHref: "#setup_glyph-0-1",
    xlinkShow: "embed",
    xlinkType: "simple"
  }), /*#__PURE__*/React.createElement("use", {
    x: 125.73718,
    y: 290.10471,
    width: "100%",
    height: "100%",
    xlinkActuate: "onLoad",
    xlinkHref: "#setup_glyph-0-2",
    xlinkShow: "embed",
    xlinkType: "simple"
  }), /*#__PURE__*/React.createElement("use", {
    x: 146.00063,
    y: 290.10471,
    width: "100%",
    height: "100%",
    xlinkActuate: "onLoad",
    xlinkHref: "#setup_glyph-0-3",
    xlinkShow: "embed",
    xlinkType: "simple"
  }), /*#__PURE__*/React.createElement("use", {
    x: 158.66757,
    y: 290.10471,
    width: "100%",
    height: "100%",
    xlinkActuate: "onLoad",
    xlinkHref: "#setup_glyph-0-4",
    xlinkShow: "embed",
    xlinkType: "simple"
  }), /*#__PURE__*/React.createElement("use", {
    x: 179.6449,
    y: 290.10471,
    width: "100%",
    height: "100%",
    xlinkActuate: "onLoad",
    xlinkHref: "#setup_glyph-0-5",
    xlinkShow: "embed",
    xlinkType: "simple"
  })), /*#__PURE__*/React.createElement("use", {
    x: 200.75037,
    y: 290.10471,
    width: "100%",
    height: "100%",
    xlinkActuate: "onLoad",
    xlinkHref: "#setup_glyph-0-6",
    xlinkShow: "embed",
    xlinkType: "simple"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.072873 0 0 .072873 -1.8864 -1.9231)"
  }, /*#__PURE__*/React.createElement("use", {
    x: 210.08582,
    y: 290.10471,
    width: "100%",
    height: "100%",
    xlinkActuate: "onLoad",
    xlinkHref: "#setup_glyph-0-7",
    xlinkShow: "embed",
    xlinkType: "simple"
  }), /*#__PURE__*/React.createElement("use", {
    x: 230.18452,
    y: 290.10471,
    width: "100%",
    height: "100%",
    xlinkActuate: "onLoad",
    xlinkHref: "#setup_glyph-0-8",
    xlinkShow: "embed",
    xlinkType: "simple"
  }), /*#__PURE__*/React.createElement("use", {
    x: 251.18016,
    y: 290.10471,
    width: "100%",
    height: "100%",
    xlinkActuate: "onLoad",
    xlinkHref: "#setup_glyph-0-9",
    xlinkShow: "embed",
    xlinkType: "simple"
  }), /*#__PURE__*/React.createElement("use", {
    x: 78.152344,
    y: 341.85471,
    width: "100%",
    height: "100%",
    xlinkActuate: "onLoad",
    xlinkHref: "#setup_glyph-0-10",
    xlinkShow: "embed",
    xlinkType: "simple"
  }), /*#__PURE__*/React.createElement("use", {
    x: 110.9912,
    y: 341.85471,
    width: "100%",
    height: "100%",
    xlinkActuate: "onLoad",
    xlinkHref: "#setup_glyph-0-7",
    xlinkShow: "embed",
    xlinkType: "simple"
  }), /*#__PURE__*/React.createElement("use", {
    x: 131.08989,
    y: 341.85471,
    width: "100%",
    height: "100%",
    xlinkActuate: "onLoad",
    xlinkHref: "#setup_glyph-0-11",
    xlinkShow: "embed",
    xlinkType: "simple"
  }), /*#__PURE__*/React.createElement("use", {
    x: 141.02942,
    y: 341.85471,
    width: "100%",
    height: "100%",
    xlinkActuate: "onLoad",
    xlinkHref: "#setup_glyph-0-8",
    xlinkShow: "embed",
    xlinkType: "simple"
  }), /*#__PURE__*/React.createElement("use", {
    x: 162.02505,
    y: 341.85471,
    width: "100%",
    height: "100%",
    xlinkActuate: "onLoad",
    xlinkHref: "#setup_glyph-0-3",
    xlinkShow: "embed",
    xlinkType: "simple"
  }), /*#__PURE__*/React.createElement("use", {
    x: 174.692,
    y: 341.85471,
    width: "100%",
    height: "100%",
    xlinkActuate: "onLoad",
    xlinkHref: "#setup_glyph-0-2",
    xlinkShow: "embed",
    xlinkType: "simple"
  }), /*#__PURE__*/React.createElement("use", {
    x: 194.95544,
    y: 341.85471,
    width: "100%",
    height: "100%",
    xlinkActuate: "onLoad",
    xlinkHref: "#setup_glyph-0-8",
    xlinkShow: "embed",
    xlinkType: "simple"
  }), /*#__PURE__*/React.createElement("use", {
    x: 215.95108,
    y: 341.85471,
    width: "100%",
    height: "100%",
    xlinkActuate: "onLoad",
    xlinkHref: "#setup_glyph-0-7",
    xlinkShow: "embed",
    xlinkType: "simple"
  }), /*#__PURE__*/React.createElement("use", {
    x: 236.04977,
    y: 341.85471,
    width: "100%",
    height: "100%",
    xlinkActuate: "onLoad",
    xlinkHref: "#setup_glyph-0-8",
    xlinkShow: "embed",
    xlinkType: "simple"
  }), /*#__PURE__*/React.createElement("use", {
    x: 257.04541,
    y: 341.85471,
    width: "100%",
    height: "100%",
    xlinkActuate: "onLoad",
    xlinkHref: "#setup_glyph-0-12",
    xlinkShow: "embed",
    xlinkType: "simple"
  }), /*#__PURE__*/React.createElement("use", {
    x: 276.59497,
    y: 341.85471,
    width: "100%",
    height: "100%",
    xlinkActuate: "onLoad",
    xlinkHref: "#setup_glyph-0-2",
    xlinkShow: "embed",
    xlinkType: "simple"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetup);
export default __webpack_public_path__ + "static/media/setup.37f3d132.svg";
export { ForwardRef as ReactComponent };